function removeDuplicates(array, key) {
  const arrayObject = array.reduce(
    (acc, current) => ({ ...acc, [current[key]]: current }),
    {},
  );
  return Object.values(arrayObject);
}
export default removeDuplicates;
